<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    bottom
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        dark
        icon
        :title="$t('userMenu.myAccountBtnTitle')"
        class="ma-1"
        small
      >
        <v-icon>person</v-icon>
      </v-btn>
    </template>
    <v-card
      width="200px"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar
            color="orange lighten-1 white--text"
          >
            {{ userNameFirstLetter }}
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title :title="userName">
              {{ userName }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ role }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          @click="menuItemClick(item.eventName)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>

        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'userMenu',
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    menuItems() {
      return [
        {
          icon: 'exit_to_app',
          title: this.$t('userMenu.logoutBtnTitle'),
          eventName: 'logout',
        },
      ];
    },
  },
  methods: {
    menuItemClick(eventName) {
      this.$emit(eventName);
    },
  },
  props: {
    userName: {
      type: String,
    },
    role: {
      type: String,
    },
    userNameFirstLetter: {
      type: String,
    },
  },
};
</script>

<i18n>
{
  "en": {
    "userMenu": {
      "myAccountBtnTitle": "My Account",
      "logoutBtnTitle": "Logout"
    }
  }
}
</i18n>
